import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import User from './pages/user/User'
import UserView from './pages/user/View'
import Lead from './pages/Lead/Lead';
import DashboardAppPage from './pages/DashboardAppPage';
import LeadView from './pages/Lead/View'
import BankrateLead from './pages/BankrateLead/BankrateLead';
import BankrateLeadView from './pages/BankrateLead/View';
import Contact from './pages/contact/Contact';
import ContactView from './pages/contact/View'
import Policy from './pages/policy/Policy'
import PolicyView from './pages/policy/View'
import  Calendar  from './pages/Calendar/Calendar';
import Document from './pages/documents/Documents';
import Calls from './pages/calls/Call';
import CallsView from './pages/calls/View'
import Meeting from './pages/meeting/Meeting';
import MeetingView from './pages/meeting/View'
import Email from './pages/email/Email'
import EmailView from './pages/email/View'
import Task from './pages/task/Task';
import TaskView from './pages/task/View'
import EmailTemplate from './pages/emailTemplate/EmailTemplate';
import AddEmailTemplate from './pages/emailTemplate/Add'
import ViewEmailTemplate from './pages/emailTemplate/View'
import LandingPage from './pages/landingpage/landingpage';
import ExclusiveLeadsPage from './pages/landingpage/exclusiveleadpage';
import DocuSignPage from './pages/docusign/docusign';
import Loan from './pages/Loan/Loan';
import LoanView from './pages/Loan/View'
import CreateLOPage from './pages/Agents/CreateLOPage';
import Blog from './pages/Blog/Blog';
import ViewBlogPost from './pages/Blog/View';
import CherryCreek from './pages/CherryCreek/CherryCreek';
import StationLoanView from './pages/CherryCreek/View';
import BorrowerLoans from './pages/Borrower/BorrowerLoans';
import LoanOfficerDashboard from './pages/LoanOfficer/LoanOfficerDashboard';
import LoanOfficerProfile from './pages/Agents/LoanOfficerProfile';
import BorrowerLoanDetail from './pages/Borrower/BorrowerLoanDetail';
import StateDashboard from './pages/states/StateDashboard';
import StateCreateForm from './components/state/StateCreateForm';
import BranchDashboard from './pages/Branch/BranchDashboard';
import BranchCreateForm from './components/branch/BranchCreateForm';
import StateProfile from './pages/states/View';
import BranchProfile from './pages/Branch/View';
import BuilderIntakeDashboard from './pages/BuilderIntake/BuilderIntakeDashboard';
import BuilderIntakeCreateForm from './components/builderintakeforms/BuilderIntakeCreateForm';
import BuilderIntakeProfile from './pages/BuilderIntake/View';
// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <User /> },
        { path: 'Docusign', element: <DocuSignPage /> },
        { path: 'user/view/:id', element: <UserView /> },
        { path: 'lead', element: <Lead /> },
        { path: 'lead/view/:id', element: <LeadView /> },
        { path: 'bankrate-lead', element: <BankrateLead /> },
        { path: 'bankrate-lead/view/:id', element: <BankrateLeadView /> },
        { path: 'contact', element: <Contact /> },
        { path: 'contact/view/:id', element: <ContactView /> },
        { path: 'policy', element: <Policy /> },
        { path: 'policy/view/:id', element: <PolicyView /> },
        { path: 'calendar', element: <Calendar /> },
        { path: 'document', element: <Document /> },
        { path: 'landingpage', element: <LandingPage /> },
        { path: 'exclusiveleads', element: <ExclusiveLeadsPage /> },
        { path: 'call', element: <Calls /> },
        { path: 'call/view/:id', element: <CallsView /> },
        { path: 'meeting', element: <Meeting /> },
        { path: 'meeting/view/:id', element: <MeetingView /> },
        { path: 'email', element: <Email /> },
        { path: 'email/view/:id', element: <EmailView /> },
        { path: 'task', element: <Task /> },
        { path: 'task/view/:id', element: <TaskView /> },
        { path: 'emailtemplate', element: <EmailTemplate /> },
        { path: 'emailtemplate/add', element: <AddEmailTemplate /> },
        { path: 'emailtemplate/view/:id', element: <ViewEmailTemplate /> },
        { path: 'loan', element: <Loan /> },
         { path: 'borrower/loan', element: <BorrowerLoans /> },
         { path: 'borrower/loan/:id', element: <BorrowerLoanDetail /> },
        { path: 'loan/view/:id', element: <LoanView /> },
        { path: 'blog', element: <Blog /> },
        { path: 'blog/:id', element: <ViewBlogPost/> },
        { path: 'cherrycreek', element: <CherryCreek/> },
        { path: 'cherrycreek/:id', element: <StationLoanView/> },
        { path: 'cherrycreek/stationsloan/:id/doc/:docId/preview', element: <StationLoanView/> },
         { path:'createLO', element:<CreateLOPage />},
         { path: 'loanofficers', element: <LoanOfficerDashboard /> }, 
         { path: 'states', element: <StateDashboard/> }, 
         { path: 'states/:id', element: <StateProfile/> }, 
          { path: 'intake', element: <BuilderIntakeDashboard/> }, 
           { path: 'intake/:id', element: <BuilderIntakeProfile/> }, 
            { path: 'intake/create', element: <BuilderIntakeCreateForm/> }, 
          { path: 'states/create', element: <StateCreateForm/> }, 
           { path: 'branches', element: <BranchDashboard/> }, 
           { path: 'branches/:id', element: <BranchProfile/> }, 
          { path: 'branches/create', element: <BranchCreateForm/> }, 
         { path: 'loanofficers/:slug', element: <LoanOfficerProfile /> }, 
        // { path: 'history', element: <History /> },
        
        // { path: '*', element: <Navigate to="/dashboard/app" /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        {path: '*', element: <Navigate to="/dashboard/app" />, index: true },
        // { path: '404', element: <Page404 /> },
        // { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    // {
    //   path: '*',
    //   element: <Navigate to="/404" replace />,
    // },
  ]);

  return routes;
}
